import React from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, LogOut, Sun, Moon, User } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

// Todas as rotas do sistema são de 1 nível só (ver App.jsx — nenhuma tem
// sub-rota tipo /ordens/:id), então a página atual é sempre um nome só, não
// uma cadeia. Um breadcrumb de verdade (com ícone de atalho, setas, etc.)
// era complexidade sem uso real — virou só o nome da página em negrito
// (13/08/2026, limpeza do topbar).
const routeLabels = {
    '/': 'Painel',
    '/chao-fabrica': 'Chão de Fábrica',
    '/ordens': 'Ordens de Produção',
    '/producao': 'Produção',
    '/maquinarios': 'Maquinário',
    '/manutencao': 'Manutenção',
    '/alertas': 'Alertas',
    '/relatorios': 'Relatórios',
    '/equipe': 'Equipe',
    '/configuracoes': 'Configurações',
    '/usuarios': 'Usuários',
};

export default function Header({ onToggleSidebar, onLogout, nomeUsuario }) {
    const location = useLocation();
    const { theme, toggleTheme } = useTheme();
    const pageTitle = routeLabels[location.pathname] || 'Painel';

    return (
        <header className="sticky top-5 z-30 mx-5 mb-5">
            <div className="mes-glass topo px-5 lg:px-6 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <button
                        onClick={onToggleSidebar}
                        className="p-2 rounded-xl hover:bg-white/[0.04] text-anthracite-400 hover:text-anthracite-200 transition-all duration-200"
                    >
                        <Menu size={18} />
                    </button>

                    <span className="topo__titulo">{pageTitle}</span>
                </div>

                <div className="flex items-center gap-2">
                    {/* Theme Toggle */}
                    <button
                        onClick={toggleTheme}
                        className="p-2 rounded-xl hover:bg-white/[0.04] text-anthracite-400 hover:text-anthracite-200 transition-all duration-200"
                        title={theme === 'dark' ? 'Modo claro' : 'Modo escuro'}
                    >
                        {theme === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
                    </button>

                    {/* Nome do usuário — só aparece quando não tem sidebar (operador, ver
                        MainLayout), já que é o rodapé do menu lateral que normalmente mostra isso. */}
                    {nomeUsuario && (
                        <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-xl bg-white/[0.03] border border-white/[0.04] text-anthracite-300">
                            <User size={14} className="text-anthracite-500" />
                            <span className="text-[12px] font-semibold truncate max-w-[140px]">{nomeUsuario}</span>
                        </div>
                    )}

                    {/* Logout */}
                    <button
                        onClick={onLogout}
                        className={nomeUsuario
                            ? 'flex items-center gap-1.5 px-3 py-2 rounded-xl bg-red-500/10 border border-red-500/15 text-red-400 hover:bg-red-500/15 transition-all duration-200 text-[12px] font-semibold'
                            : 'p-2 rounded-xl hover:bg-white/[0.04] text-anthracite-400 hover:text-anthracite-200 transition-all duration-200'}
                    >
                        <LogOut size={nomeUsuario ? 15 : 17} />
                        {nomeUsuario && <span>Sair</span>}
                    </button>
                </div>
            </div>
        </header>
    );
}
